import React, { Component } from 'react';
import NavigationContainer from 'components/navigation/NavigationContainer'

class Main extends Component {
  constructor(props){
    super()
  }

  render() {
    return (
      <NavigationContainer />
    )
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/scripts/Main.js